import FloatingPreferencesButton from './FloatingPreferencesButton'

export default FloatingPreferencesButton
